import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    class: "remove-button",
    variant: "text",
    icon: "",
    size: "x-small",
    title: _ctx.$tt('remove')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_icon, {
        size: "x-small",
        icon: "mdi-close"
      })
    ]),
    _: 1
  }, 8, ["title"]))
}